import React from "react";

// Consistent SVG icon wrappers for the landing page.
// Stroke-based, rounded, 1.5-2px stroke, limited palette.

function Wrap({ children, size = 48, bg = "#EEF2FF", className = "" }) {
  return (
    <div
      aria-hidden="true"
      className={`inline-flex items-center justify-center rounded-2xl ${className}`}
      style={{ width: size, height: size, background: bg }}
    >
      {children}
    </div>
  );
}

const S = { stroke: "#4F46E5", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round", fill: "none" };

// --- Problem icons ---

export function LatePaymentIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
        <line x1="4" y1="4" x2="20" y2="20" stroke="#DC2626" strokeWidth="1.75" />
      </svg>
    </Wrap>
  );
}

export function TrackingDifficultyIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="9" y1="13" x2="15" y2="13" />
        <line x1="9" y1="17" x2="13" y2="17" />
        <circle cx="18" cy="18" r="4" stroke="#F59E0B" strokeWidth="1.75" fill="#FEF3C7" />
        <line x1="18" y1="16" x2="18" y2="18" stroke="#F59E0B" strokeWidth="1.75" />
        <circle cx="18" cy="20" r="0.5" fill="#F59E0B" />
      </svg>
    </Wrap>
  );
}

export function ManualWorkIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
        <path d="m15 5 4 4" />
      </svg>
    </Wrap>
  );
}

export function DisorganizationIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
        <line x1="5" y1="5" x2="8" y2="8" stroke="#DC2626" strokeWidth="1.5" />
        <line x1="8" y1="5" x2="5" y2="8" stroke="#DC2626" strokeWidth="1.5" />
      </svg>
    </Wrap>
  );
}

// --- Solution icons ---

export function DashboardIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <rect x="3" y="3" width="7" height="9" rx="1" />
        <rect x="14" y="3" width="7" height="5" rx="1" />
        <rect x="14" y="12" width="7" height="9" rx="1" />
        <rect x="3" y="16" width="7" height="5" rx="1" />
      </svg>
    </Wrap>
  );
}

export function PaymentTrackingIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <line x1="2" y1="10" x2="22" y2="10" />
        <path d="M12 15h4" />
      </svg>
    </Wrap>
  );
}

export function AlertsIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        <circle cx="18" cy="4" r="3" fill="#DC2626" stroke="none" />
      </svg>
    </Wrap>
  );
}

export function CommunicationIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z" />
        <line x1="8" y1="8" x2="16" y2="8" />
        <line x1="8" y1="12" x2="13" y2="12" />
      </svg>
    </Wrap>
  );
}

// --- How it works step icons ---

export function AddPropertyIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
        <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
        <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
        <line x1="12" y1="8" x2="12" y2="14" stroke="#16A34A" strokeWidth="2" />
        <line x1="9" y1="11" x2="15" y2="11" stroke="#16A34A" strokeWidth="2" />
      </svg>
    </Wrap>
  );
}

export function AddTenantIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <line x1="19" y1="8" x2="19" y2="14" stroke="#16A34A" strokeWidth="2" />
        <line x1="16" y1="11" x2="22" y2="11" stroke="#16A34A" strokeWidth="2" />
      </svg>
    </Wrap>
  );
}

export function TrackPaymentsIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    </Wrap>
  );
}

export function FollowUpIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92Z" />
      </svg>
    </Wrap>
  );
}

// --- Feature icons ---

export function TenantMgmtIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    </Wrap>
  );
}

export function AiCallingIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <path d="M12 2a3 3 0 0 0-3 3v4a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
        <path d="M19 10v1a7 7 0 0 1-14 0v-1" />
        <line x1="12" y1="18" x2="12" y2="22" />
        <path d="M8 22h8" />
        <path d="M2 6c1.5-1.5 3.5-2 5.5-2" stroke="#4F46E5" strokeWidth="1.5" opacity="0.4" />
        <path d="M22 6c-1.5-1.5-3.5-2-5.5-2" stroke="#4F46E5" strokeWidth="1.5" opacity="0.4" />
      </svg>
    </Wrap>
  );
}

export function NotificationsIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <path d="M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3Z" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
    </Wrap>
  );
}

export function RentTrackingIcon({ size = 48, bg }) {
  return (
    <Wrap size={size} bg={bg}>
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} {...S}>
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    </Wrap>
  );
}
